var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._b({staticClass:"oss-media-link",attrs:{"href":"#"},on:{"click":_vm.handleClick}},'a',_vm.forwardedAttrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }